import { Outlet } from 'react-router-dom'
import { BottomTabBar } from './bottom-tab-bar'

// Two layouts, both phone-first single columns centered + width-capped on big
// screens (don't stretch). TabLayout = top-level destinations with the bottom
// tab bar. PlainLayout = full-screen pushed screens (detail/create/edit) with
// no tab bar — they carry a back affordance in their own TopBar.

function Column({ children }: { children: React.ReactNode }) {
  return (
    <div className="main h-[100dvh] mx-auto w-full max-w-screen-sm flex flex-col bg-[var(--bg-deep)] overflow-hidden">
      {children}
    </div>
  )
}

export function TabLayout() {
  return (
    <Column>
      <main className="flex-1 min-h-0 overflow-y-auto flex flex-col">
        <Outlet />
      </main>
      <BottomTabBar />
    </Column>
  )
}

export function PlainLayout() {
  return (
    <Column>
      <main className="flex-1 min-h-0 overflow-y-auto flex flex-col">
        <Outlet />
      </main>
    </Column>
  )
}
